import { CreatePaymentStatus } from '@/store/slices/stagesSlice/interfaces'
import { checkPayment, getPaymentState } from '@/store/slices/stagesSlice/stagesSlice'
import { useRouter } from 'next/router'
import { useCallback, useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { Title, Container, Button, FixedBottom } from '@/components'
import { supportPhoneLink } from '@/constants'
import styles from './PaymentPendingPage.module.scss'
import getLinkHref from '@/helpers/getLinkHref'
import { RootState } from '@/store'
import { STATUS_PAYMENT_MESSAGES } from './PaymentPendingPage.constants'
import { useFetchPaymentStatus } from '@/helpers/hooks/useFetchPaymentStatus'

export default function PaymentPendingPage({ orderNumber, subscriptionId, eventId }: { orderNumber: string, subscriptionId?: string, eventId?: string }) {
  const [status, setStatus] = useState<CreatePaymentStatus | 'exhausted'>('pending')
  const [formUrl, setFormUrl] = useState<string | null>(null)
  const dispatch = useDispatch()
  const router = useRouter()
  const reduxState = useSelector<RootState, RootState>(state => state)
  const { data } = getPaymentState(reduxState)
  const hrefFindCar = getLinkHref({ type: 'find-car-number', data: { id: data.area?.id } })
  const hrefMainPage = getLinkHref({ type: 'area', data: { id: data.area?.id } })
  const hrefSubscriptionFindCar = subscriptionId
    ? getLinkHref({ type: 'subscription-number', data: { areaId: data.area?.id, subscriptionId } })
    : ''

  const hrefEventFindCar = eventId ? getLinkHref({ type: 'event-number', data: { areaId: data.area?.id, eventId } }) : ''
  const isErrorApiStatus = status === 'error' || status === 'canceled' || status === 'expired'
  const isExhaustedStatus = status === 'exhausted'

  const goToMainPage = () => {
    router.push(hrefMainPage)
  }

  const goToFindCarPage = () => {
    if (hrefSubscriptionFindCar) {
      router.push(hrefSubscriptionFindCar)
      return
    }
    
    if (hrefEventFindCar) {
      router.push(hrefEventFindCar)
      return
    }
      
    router.push(hrefFindCar)
  }

  const fetchData = useCallback(async () => {
    await dispatch(
      checkPayment({
        token: orderNumber,
        onSuccess: ({ status, formUrl }) => {
          setStatus(status)
          formUrl && setFormUrl(formUrl)
        },
        onError: (status) => {
          setStatus(status)
        } 
      }),
    )
  }, [])

  useFetchPaymentStatus({fetchData, status, setStatus})

  useEffect(()=>{
    if (formUrl) {
      router.push(formUrl)
    }
  },[formUrl])

  return (
    <section className={styles.section}>
      <Container className={styles.container}>
        <div className={styles.container__inner}>
          <Title align="center">{STATUS_PAYMENT_MESSAGES[status]}</Title>
        </div>

        <FixedBottom>
          <Container className={styles.buttons}>
            {isExhaustedStatus && (
              <Button
                component="button"
                className={styles.button}
                onClick={() => {
                  router.reload()
                }}
              >
                Перезагрузить страницу
              </Button>
            )}

            {isErrorApiStatus && (
              <Button component="button" className={styles.button} onClick={goToFindCarPage}>
                Повторить попытку оплаты
              </Button>
            )}

            {
              <Button component="button" className={styles.button} onClick={goToMainPage}>
                На главную
              </Button>
            }

            <Button component="a" href={supportPhoneLink} className={styles.button} isTransparent>
              Обратиться в поддержку
            </Button>
          </Container>
        </FixedBottom>
      </Container>
    </section>
  )
}
